import { AfterContentInit, Component, ContentChildren, QueryList } from '@angular/core';
import { SimpleTabComponent } from '../tab/tab.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'finder-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss'],
    standalone: true,
    imports: [ CommonModule ]
})
export class TabsComponent implements AfterContentInit {
    @ContentChildren(SimpleTabComponent) tabs: QueryList<SimpleTabComponent>;

    constructor() { }

    ngAfterContentInit() {
        // Get all active tabs
        const activeTabs = this.tabs.filter(tab => tab.active());

        // If there is no active tab set, activate the first
        if (activeTabs.length === 0) {
            this.selectTab(this.tabs.first);
        }
    }

    selectTab(tab) {
        // Don't bother if we have no tab
        if (!tab) {
            return;
        }

        // Deactivate all tabs
        this.tabs.toArray().forEach(t => {
            if (!t) {
                return;
            }

            // Turn the tab off
            t.active.set(false);
        });

        // Activate the clicked tab
        tab.active.set(true);
    }
}
